import Row from "../../../layout/Row";
import Col from "../../../layout/Col";
import * as React from "react";
import TrackingData from "../../../../model/lead/TrackingData";
import {none, option, Option} from "ts-option";
import Modal from "../../../ui/modal/Modal";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import Input from "../../../../hiberUiKit/src/atoms/Input/Input";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface IComponentProps {
	/**
	 * Tracking
	 */
	tracking: Option<TrackingData>;
	/**
	 * On close callback
	 */
	onClose: () => void;
	/**
	 * On change callback
	 * @param {Option<TrackingData>} tracking
	 */
	onChange: (tracking: Option<TrackingData>) => void;
}


interface IState {
	/**
	 * Temporary campaign value
	 */
	campaignTmp: Option<string>;
	/**
	 * Temporary source value
	 */
	sourceTmp: Option<string>;
	/**
	 * Temporary ad group value
	 */
	adGroupTmp: Option<string>;
	/**
	 * Temporary landing page value
	 */
	landingPageTmp: Option<string>;
	/**
	 * Temporary url value
	 */
	urlTmp: Option<string>;
}

type Props = IComponentProps

export default class MarketingAndTrackingModal extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		if (this.props.tracking.isDefined) {
			const t = this.props.tracking.get;
			this.state = {
				campaignTmp: t.campaign,
				sourceTmp: t.source,
				adGroupTmp: t.adGroup,
				landingPageTmp: t.landingPage,
				urlTmp: t.url
			};
		}
		else {
			this.state = {campaignTmp: none, sourceTmp: none, adGroupTmp: none, landingPageTmp: none, urlTmp: none};
		}
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Inbound Marketing & Tracking"}>
				<Row>
					<Col lg={6} xl={6}>
						<FormGroup label={"Campaign"}>
							<Input type={"text"}
								   onChange={evt => this.setState({campaignTmp: option(evt.target.value)})}
								   value={this.state.campaignTmp.getOrElse("")}/>
						</FormGroup>
					</Col>
					<Col lg={6} xl={6}>
						<FormGroup label={"Source"}>
							<Input type={"text"}
								   onChange={evt => this.setState({sourceTmp: option(evt.target.value)})}
								   value={this.state.sourceTmp.getOrElse("")}/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col lg={6} xl={6}>
						<FormGroup label={"Ad Group"}>
							<Input type={"text"}
								   onChange={evt => this.setState({adGroupTmp: option(evt.target.value)})}
								   value={this.state.adGroupTmp.getOrElse("")}/>
						</FormGroup>
					</Col>
					<Col lg={6} xl={6}>
						<FormGroup label={"Landing Page"}>
							<Input type={"text"}
								   onChange={evt => this.setState({landingPageTmp: option(evt.target.value)})}
								   value={this.state.landingPageTmp.getOrElse("")}/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col lg={6} xl={6}>
						<FormGroup label={"URL"}>
							<Input type={"text"}
								   onChange={evt => this.setState({urlTmp: option(evt.target.value)})}
								   value={this.state.urlTmp.getOrElse("")}/>
						</FormGroup>
					</Col>
				</Row>
				<FormButtonsView align={"right"}>
					<div style={{paddingTop: "20px"}}>
						<div className="pull-left">
							<ButtonTertiary label="Cancel"
											onClick={this.props.onClose}/>
						</div>
						<ButtonPrimary label={"Change"}
									   onClick={this.onChange}/>
					</div>
				</FormButtonsView>
			</Modal>
		)
	}

	onChange() {
		if (this.state.campaignTmp.isEmpty && this.state.adGroupTmp.isEmpty && this.state.landingPageTmp.isEmpty &&
			this.state.sourceTmp.isEmpty && this.state.urlTmp.isEmpty) {
			this.props.onChange(none);
		}
		else {
			this.props.onChange(option(new TrackingData(
				this.state.campaignTmp,
				this.state.sourceTmp,
				this.state.adGroupTmp,
				this.state.landingPageTmp,
				this.state.urlTmp))
			)
		}
	}
}